<section class="exhibitor-directory">
  <header class="exhibitor-directory-header">
    <bau365-breadcrumb [breadcrumbElements]="breadcrumbElements"></bau365-breadcrumb>
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-phone mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-8-desktop headline-align">
          @if ((isBauInsights$ | async) === true) {
          <h1 class="mat-headline-4" i18n="@@featureExhibitorDirectory-pageHeader-companyDirectory-header"
            >Unternehmensverzeichnis</h1
          >
          } @if ((isBauInsights$ | async) !== true) {
          <h1 class="mat-headline-4" i18n="@@featureExhibitorDirectory-pageHeader-exhibitorDirectory-header"
            >Ausstellerverzeichnis</h1
          >
          }
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-1-phone mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-desktop search-field">
          <bau365-display-name-search-input
            [entityType]="'exhibitor'"
            [submittedSearchTerm]="searchTerm"
            [size]="size$ | async"
            [placeholderText]="searchPlaceholderText"
            (searchTerm)="triggerSearch($event)"></bau365-display-name-search-input>
        </div>
        <nav
          mat-tab-nav-bar
          [tabPanel]="tabPanel"
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-phone mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-12-desktop filter-options">
          <a
            mat-tab-link
            [routerLink]="['/fairs', fairId, 'exhibitors', 'letters']"
            [queryParams]="{ character: 'A' }"
            class="filter-options--item"
            [class]="{
              'filter-options__active': tab === 'exhibitor'
            }">
            @if ((isBauInsights$ | async) === true) {
            <span
              [class]="{
                'filter-options__active-text': tab === 'exhibitor'
              }"
              i18n="@@featureExhibitorDirectory-pageHeader-companyFilterHeader"
              >Unternehmen</span
            >
            } @if ((isBauInsights$ | async) !== true) {
            <span
              [class]="{
                'filter-options__active-text': tab === 'exhibitor'
              }"
              i18n="@@featureExhibitorDirectory-pageHeader-exhibitorFilterHeader"
              >Aussteller</span
            >
            }
          </a>
          @if ((isBauInsights$ | async) !== true) {
          <a
            mat-tab-link
            [routerLink]="['/fairs', fairId, 'exhibitors', 'halls']"
            [queryParams]="{ hallId: firstAvailableHall }"
            class="filter-options--item"
            [class]="{
              'filter-options__active': tab === 'hall'
            }"
            i18n="@@featureExhibitorDirectory-pageHeader-hallFilterHeader"
            ><span
              [class]="{
                'filter-options__active-text': tab === 'hall'
              }">
              Halle
            </span></a
          >
          }
        </nav>
      </div>
    </div>
  </header>
  <mat-tab-nav-panel #tabPanel>
    <section class="exhibitor-directory-wrapper">
      @if (fairConfig$ | async; as fairConfig) { @if (fairConfig.advertisements.skyscraper.enabled) {
      <bau365-skyscraper-advertisement
        [siteId]="fairConfig.advertisements.skyscraper.siteId"
        [pageIds]="fairConfig.advertisements.skyscraper.pageIds"
        [format]="fairConfig.advertisements.skyscraper.format"></bau365-skyscraper-advertisement>
      } }
      <section class="exhibitor-directory-filter">
        <div class="mdc-layout-grid selector-wrapper">
          <div class="mdc-layout-grid__inner">
            <div
              class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 selectors"
              [class.selectors--left]="fairId === '185' && tab === 'hall'"
              [class.selector-anonymous]="!isLoggedIn">
              @for (sortItem of sortIndex; track trackByIndex($index, sortItem)) {
              <a
                [routerLink]="['/fairs', fairId, 'exhibitors', tab === 'exhibitor' ? 'letters' : 'halls']"
                [queryParams]="tab === 'exhibitor' ? { character: sortItem } : { hallId: sortItem }"
                class="button-letter"
                [class]="{
                  'button-letter--active': activeLetter === sortItem
                }">
                {{ sortItem }}
              </a>
              }
            </div>
          </div>
        </div>
        <div class="selector-placeholder"></div>
      </section>
      <section class="result">
        <div class="mdc-layout-grid">
          <div class="mdc-layout-grid__inner">
            @if ( (exhibitorDirectoryStatus$ | async)?.first === true || (exhibitorDirectoryStatus$ | async)?.failed ===
            true) { @if ( (exhibitorDirectoryStatus$ | async)?.failed === true || (exhibitorDirectory$ | async)?.length
            === 0) { @if (activeSearch === false) {
            <div
              class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-phone mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--start-2-tablet mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--start-4-desktop no-results-panel">
              <img class="no-results-message__img" src="assets/search/person-searching.svg" />
              <p class="no-results-message__text">
                <span class="no-results-text" i18n="@@featureExhibitorDirectory-no-results"
                  >Leider keine Ergebnisse für</span
                >
                <strong class="search-term"> "{{ activeLetter }}"</strong>
              </p>
            </div>
            } @else {
            <div
              class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-phone mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-12-desktop no-results-panel">
              <h4 i18n="@@featureExhibitorDirectory-no-search-result-header" class="mat-headline-4"
                >Wir konnten nichts zur Suche "{{ searchTerm }}" finden</h4
              >
              <p i18n="@@featureExhibitorDirectory-no-search-result-message"
                >Bitte prüfen Sie die Rechtschreibung oder probieren Sie es mit einem anderen Begriff, wenn Sie eine
                neue Suche starten.</p
              >
            </div>
            } } @else {
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
              <div class="group-section" [id]="activeLetter">
                <div class="group-section__headline">
                  @if (!activeSearch) {
                  <h2 class="group-section__active">{{ activeLetter }}</h2>
                  } @if (activeSearch) {
                  <p i18n="@@featureExhibitorDirectory-search-result-counter" class="search-result-counter"
                    >{{ (exhibitorDirectoryStatus$ | async)?.searchStatus?.count }} {(exhibitorDirectoryStatus$ |
                    async)?.searchStatus?.count, plural, =1 { Ergebnis } other { Ergebnisse }} für "{{
                      (exhibitorDirectoryStatus$ | async)?.searchStatus?.searchTerm
                    }}"</p
                  >
                  } @if (fairConfig$ | async; as fairConfig) { @if (!fairConfig.discoveryHidden) {
                  <div class="group-section__export" i18n="@@featureExhibitorDirectory-export-action">
                    <mat-icon class="group-section__icon">info</mat-icon>
                    Unter
                    <a
                      class="group-section__link"
                      [routerLink]="['/fairs/', fairId, 'search']"
                      [queryParams]="{
                        searchTypes: 'EXHIBITOR',
                        sort: 'ALPHABETICAL_ASC',
                        searchTerm: (exhibitorDirectoryStatus$ | async)?.searchStatus?.searchTerm
                      }">
                      Entdecken</a
                    >
                    steht Ihnen die Exportmöglichkeit zur Verfügung.
                  </div>
                  } }
                </div>
                <div class="mdc-layout-grid exhibitor-list">
                  <div class="mdc-layout-grid__inner">
                    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 exhibitor-list-item-wrapper">
                      @for (entry of exhibitorDirectory$ | async; track trackById(i, entry); let i = $index) {
                      <bau365-directory-list-item
                        [entry]="entry"
                        [fairId]="fairId"
                        [size]="size$ | async"
                        [isPlatformFair]="(isBauInsights$ | async) === true"
                        [watchlistEnabled]="watchlistEnabled$ | async"></bau365-directory-list-item>
                      @if ((i + 1 === 5 || (i - 4) % 10 === 0) && !activeSearch) { @if (fairConfig$ | async; as
                      fairConfig) { @if (fairConfig.advertisements.parallax.enabled) {
                      <bau365-parallax-advertisement
                        [siteId]="fairConfig.advertisements.parallax.siteId"
                        [pageIds]="fairConfig.advertisements.parallax.pageIds"
                        [formats]="fairConfig.advertisements.parallax.formats"
                        [unique]="tab + i.toString()"
                        [change]="tab"></bau365-parallax-advertisement>
                      } } } } @if ( activeSearch && (totalSearchResults && loadedSearchResults ? totalSearchResults >
                      loadedSearchResults : false) ) {
                      <div class="mdc-layout-grid">
                        <div class="mdc-layout-grid__inner">
                          <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 load-more__wrapper">
                            <button mat-button class="load-more" (click)="loadMoreSearchResults()">
                              <mat-icon class="load-more__icon">refresh</mat-icon>
                              <span
                                class="load-more__text"
                                i18n="@@featureExhibitorDirectory-load-more-search-results-button"
                                >Mehr laden</span
                              >
                            </button>
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            } } @else {
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
              <div class="loading-animation">
                <planone-loading-animation></planone-loading-animation>
              </div>
            </div>
            }
          </div>
        </div>
      </section>
    </section>
  </mat-tab-nav-panel>
</section>
<ng-template #loading>
  <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
    <div class="loading-animation">
      <planone-loading-animation></planone-loading-animation>
    </div>
  </div>
</ng-template>
